export const AvailabilityStatuses = {
  SOLD_OUT: "sold-out",
  PARTIALLY_BOOKED: "partially-booked",
  NO_BOOKINGS: "no-bookings"
};
